/**
 * This to allow for the app to run in scenarios where the local storage might not exist.
 */

/* eslint-disable import/no-mutable-exports, no-throw-literal */
import { StorageLike } from './types';

let storage: StorageLike;

try {
  if (typeof window === 'undefined' || !window.localStorage) {
    throw new Error('unable to access localStorage');
  }
  storage = window.localStorage;
} catch {
  storage = {
    getItem: () => null,
    setItem: () => null,
    removeItem: () => null,
  };
}

export default storage;
